<template>
    <div>
        <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table
                :headers="headers"
                :items="receipt_headers_master_list"
                class="elevation-1 mytable"
                :search="search"
            >
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Receipt Headers</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-col>

                        <span style="width: 20px"> </span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add New Receipt Headers</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.trust_name"
                                                        label="Trust Name"
                                                        :rules="[(v) => !!v || 'required']"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.school_name"
                                                        :rules="[(v) => !!v || 'required']"
                                                        label="School Name"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.trust_logo"
                                                        label="Trust Logo URL"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.school_logo"
                                                        label="School Logo URL"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.school_photo"
                                                        label="School Photo URL"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.bank_account_qr"
                                                        label="QR Code URL"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.watermark"
                                                        persistent-hint
                                                        label="Watermark URL"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.cbsc_affiliation"
                                                        persistent-hint
                                                        label="CBSC Affiliation"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.exam_affiliation"
                                                        persistent-hint
                                                        label="Exam Affiliation"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.address"
                                                        persistent-hint
                                                        label="Address"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.school_no"
                                                        persistent-hint
                                                        label="School No"
                                                    ></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.pin"
                                                        persistent-hint
                                                        label="Pincode"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.phone"
                                                        persistent-hint
                                                        label="Phone No."
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.email"
                                                        persistent-hint
                                                        label="Email Id"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.website"
                                                        persistent-hint
                                                        label="Website"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.line1"
                                                        persistent-hint
                                                        label="Line 1"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.line2"
                                                        persistent-hint
                                                        label="Line 2"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.signature"
                                                        persistent-hint
                                                        label="Signature"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field
                                                        v-model="editedItem.medium"
                                                        hint="English, Marathi..."
                                                        label="Medium"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete
                                                        color="#0F2027"
                                                        dense
                                                        rounded
                                                        required
                                                        v-model="editedItem.stream_id"
                                                        :items="stream_list"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Stream"
                                                        outlined
                                                        persistent-hint
                                                        hint="Please Select Stream"
                                                    />

                                                    <!-- <v-text-field
                            v-model="editedItem.stream"
                            persistent-hint
                            label="Line 2"
                            hint="Line 2"
                          ></v-text-field> -->
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete
                                                        color="#0F2027"
                                                        dense
                                                        rounded
                                                        required
                                                        v-model="editedItem.section_id"
                                                        :items="section_list"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Section"
                                                        outlined
                                                        persistent-hint
                                                        hint="Please Select Section"
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-checkbox
                                                        dense
                                                        v-model="editedItem.isactive"
                                                        color="success"
                                                        label="Active"
                                                    ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <!-- <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span>
        </template> -->
                <template v-slot:[`item.isactive`]="{ item }">
                    <v-switch
                        inset
                        v-model="item.isactive"
                        :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"
                    ></v-switch>
                </template>
                <template v-slot:[`item.trust_logo`]="{ item }">
                    <span v-if="item.trust_logo">
                        <v-img
                            :src="item.trust_logo"
                            aspect-ratio="1"
                            max-width="400"
                            class="grey lighten-2 image-zoom"
                            @click="expand(item.trust_logo)"
                        ></v-img>
                    </span>
                    <span v-else>
                        <v-skeleton-loader class="mx-auto" max-width="250" type="image"></v-skeleton-loader>
                    </span>
                </template>
                <template v-slot:[`item.school_logo`]="{ item }">
                    <span v-if="item.school_logo">
                        <v-img
                            :src="item.school_logo"
                            aspect-ratio="1"
                            max-width="400"
                            class="grey lighten-2 image-zoom"
                            @click="expand(item.school_logo)"
                        ></v-img>
                    </span>
                    <span v-else>
                        <v-skeleton-loader class="mx-auto" max-width="250" type="image"></v-skeleton-loader>
                    </span>
                </template>
                <template v-slot:[`item.school_photo`]="{ item }">
                    <span v-if="item.school_photo">
                        <v-img
                            :src="item.school_photo"
                            aspect-ratio="1"
                            max-width="400"
                            class="grey lighten-2 image-zoom"
                            @click="expand(item.school_photo)"
                        ></v-img>
                    </span>
                    <span v-else>
                        <v-skeleton-loader class="mx-auto" max-width="250" type="image"></v-skeleton-loader>
                    </span>
                </template>
                <template v-slot:[`item.bank_account_qr`]="{ item }">
                    <span v-if="item.bank_account_qr">
                        <v-img
                            :src="item.bank_account_qr"
                            aspect-ratio="1"
                            max-width="400"
                            class="grey lighten-2 image-zoom"
                            @click="expand(item.bank_account_qr)"
                        ></v-img>
                    </span>
                    <span v-else>
                        <v-skeleton-loader class="mx-auto" max-width="250" type="image"></v-skeleton-loader>
                    </span>
                </template>
                <template v-slot:[`item.watermark`]="{ item }">
                    <span v-if="item.watermark && item.watermark !== '--'">
                        <v-img
                            :src="item.watermark"
                            aspect-ratio="1"
                            max-width="400"
                            class="grey lighten-2 image-zoom"
                            @click="expand(item.watermark)"
                        ></v-img>
                    </span>
                    <span v-else>
                        <v-skeleton-loader class="mx-auto" max-width="250" type="image"></v-skeleton-loader>
                    </span>
                </template>
                <template v-slot:[`item.signature`]="{ item }">
                    <span v-if="item.signature != '--' && item.signature">
                        <v-icon class="green--text" @click="geturl(item)">mdi mdi-eye</v-icon>
                    </span>
                    <span v-else> -- </span>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:[`item.website`]="{ item }">
                    <a :href="item.website" target="_blank">{{ item.website }}</a>
                </template>
            </v-data-table>
            <v-dialog v-model="dialog2" max-width="40%" @keydown.esc="cancel">
                <v-card>
                    <v-img :src="logo" alt="" />
                </v-card>
            </v-dialog>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },
        data: () => ({
            valid: false,
            overlay: false,
            snackbar_msg: null,
            color: null,
            snackbar: false,
            search: null,
            // extraBreadcrumbItems: [
            //   { text: "Receipt Headers Master", disabled: true, href: "" },

            // ],

            // breadcrumbClass: "breadcrumb-style2",
            dialog: false,
            dialog2: false,
            logo: null,
            showSignature: false,
            headers: [
                {
                    text: "Sr No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Trust Name",
                    align: "left",
                    sortable: false,
                    value: "trust_name",
                },
                {
                    text: "School Name",
                    align: "left",
                    sortable: false,
                    value: "school_name",
                },
                {
                    text: "Trust Logo",
                    align: "left",
                    sortable: false,
                    value: "trust_logo",
                },
                {
                    text: "School Logo",
                    align: "left",
                    sortable: false,
                    value: "school_logo",
                },
                {
                    text: "School Photo",
                    align: "left",
                    sortable: false,
                    value: "school_photo",
                },
                {
                    text: "Qr Code",
                    align: "left",
                    sortable: false,
                    value: "bank_account_qr",
                },
                { text: "Watermark", align: "left", sortable: false, value: "watermark" },
                {
                    text: "CBSE Affiliation",
                    align: "left",
                    sortable: false,
                    value: "cbsc_affiliation",
                },
                {
                    text: "Exam Affiliation",
                    align: "left",
                    sortable: false,
                    value: "exam_affiliation",
                },
                {
                    text: "Address",
                    align: "left",
                    sortable: false,
                    value: "address",
                },
                {
                    text: "School No",
                    align: "left",
                    sortable: false,
                    value: "school_no",
                },

                {
                    text: "Pin",
                    align: "left",
                    sortable: false,
                    value: "pin",
                },

                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                },
                {
                    text: "Website",
                    align: "left",
                    sortable: false,
                    value: "website",
                },
                {
                    text: "Line 1",
                    align: "left",
                    sortable: false,
                    value: "line1",
                },
                {
                    text: "Line 2",
                    align: "left",
                    sortable: false,
                    value: "line2",
                },
                {
                    text: "Signature",
                    align: "left",
                    sortable: false,
                    value: "signature",
                },
                {
                    text: "Medium",
                    align: "left",
                    sortable: false,
                    value: "medium",
                },
                {
                    text: "Stream",
                    align: "left",
                    sortable: false,
                    value: "stream",
                },
                {
                    text: "Section",
                    align: "left",
                    sortable: false,
                    value: "section",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            receipt_headers_master_list: [],
            stream_list: [],
            section_list: [],
            stream: null,
            editedIndex: -1,
            addedItem: {
                id: null,
                trust_name: null,
                school_name: null,
                trust_logo: null,
                school_logo: null,
                school_photo: null,
                bank_account_qr: null,
                address: null,
                watermark: null,
                pin: null,

                school_no: null,
                phone: null,
                email: null,
                website: null,
                line1: null,
                line2: null,
                signature: null,
                cbsc_affiliation: null,
                exam_affiliation: null,
                isactive: true,
                stream: null,
                section: null,
                medium: null,
            },
            editedItem: {
                id: null,
                trust_name: null,
                school_name: null,
                trust_logo: null,
                school_logo: null,
                school_photo: null,
                bank_account_qr: null,
                address: null,
                watermark: null,
                pin: null,

                school_no: null,
                phone: null,
                email: null,
                website: null,
                line1: null,
                line2: null,
                signature: null,
                cbsc_affiliation: null,
                exam_affiliation: null,
                isactive: true,
                stream: null,
                stream_id: null,
                section_id: null,
                medium: null,
            },
            defaultItem: {
                id: null,
                trust_name: null,
                school_name: null,
                trust_logo: null,
                school_logo: null,
                school_photo: null,
                bank_account_qr: null,
                address: null,
                watermark: null,
                pin: null,

                school_no: null,
                phone: null,
                email: null,
                website: null,
                line1: null,
                line2: null,
                signature: null,
                cbsc_affiliation: null,
                exam_affiliation: null,
                isactive: true,
                stream: null,
                section: null,
                medium: null,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Add New Receipt Headers " : "Edit Receipt Headers";
            },
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },

        methods: {
            geturl(item) {
                //console.log("get url");
                //console.log(item);
                //  let route = this.$router.resolve({ path: "/website_url" });
                //       window.open(route.href);
                var signature = item.signature;
                // let route = this.$router.resolve(website);
                //        window.open(route.href);
                //alert(website);
                window.open(signature, "_blank");
            },
            toggle(item) {
                const data = {
                    receiptheaderid: item.id,
                    toggle: item.isactive,
                };
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/toggleReceiptHeadersHome", data)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Receipt Header Status Changed!"); // show snackbar
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            expand(logo) {
                this.logo = logo;
                this.dialog2 = true;
            },
            toggleSignature() {
                this.showSignature = !this.showSignature;
            },
            //   initialize () {
            initializeErrorMsgFalse() {
                this.errorMsg.name = false;
                this.errorMsg.displayname = false;
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/receiptHeadersHome")
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            this.overlay = false;
                            this.receipt_headers_master_list = res.data.receipt_headers_master_list;
                            this.stream_list = res.data.stream_list;
                            this.section_list = res.data.section_list;
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            editItem(item) {
                this.editedIndex = this.receipt_headers_master_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                if (this.editedItem.email == "--") {
                    this.editedItem.email = "";
                }
                if (this.editedItem.watermark == "--") {
                    this.editedItem.watermark = "";
                }
                this.dialog = true;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            save() {
                if (this.editedIndex > -1) {
                    if (this.editedItem.website) {
                        let regexp =
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
                        if (!regexp.test(this.editedItem.website)) {
                            this.showSnackbar("#b71c1c", "Please enter valid Website URL!");
                            return;
                        }
                    }
                    if (this.editedItem.email != null) {
                        let mailregexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                        if (!mailregexp.test(this.editedItem.email)) {
                            this.showSnackbar("#b71c1c", "Please enter valid Email Id!");
                            return;
                        }
                    }
                    // if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/editReceiptHeadersHome", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Receipt Header Details Updated Successfully!!!");
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Receipt Header Details Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.onLoad();
                    this.close();
                    // }
                } else {
                    if (this.editedItem.website != null) {
                        let regexp =
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
                        if (!regexp.test(this.editedItem.website)) {
                            this.showSnackbar("#b71c1c", "Please enter valid Website URL!");
                            return;
                        }
                    }
                    if (this.editedItem.email) {
                        let mailregexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                        if (!mailregexp.test(this.editedItem.email)) {
                            this.showSnackbar("#b71c1c", "Please enter valid Email Id!");
                            return;
                        }
                    }
                    axios
                        .post("/AdmissionMaster/saveReceiptHeadersHome", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                // this.house_master_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Receipt Header Details Added Successfully!!!"); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Receipt Header Details Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.onLoad();
                    this.close();
                }
            }, //save()
            isValidated() {
                // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
                if (this.editedItem.name) {
                    return true;
                } else {
                    if (!this.editedItem.name) {
                        this.errorMsg.name = true;
                        this.errorMsg.displayname = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }

    .image-zoom {
        cursor: zoom-in;
    }
</style>
